import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Grid, FormControlLabel, Switch, Tooltip } from '@mui/material';
import { Button, Autocomplete } from '@totalsoft/rocket-ui';
import { withTranslation } from 'react-i18next';
import OfferInsuranceProductList from './OfferInsuranceProductList';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import { Prompt } from 'react-router-dom';
import { RightsContext } from 'providers/RightsContext';

export const OfferInsurance = ({
  insurance,
  products,
  companies,
  onInsurancePropertyChange,
  onProductPropertyChange,
  onSave,
  saving,
  insuranceLoading,
  productsLoading,
  isDirty,
  isValid,
  t
}) => {
  const isNew = insurance.isNew;
  const { readOnlyFull } = useContext(RightsContext);
  return (
    <form noValidate style={{ flex: 1 }}>
      <Prompt when={isDirty} message={t('LeavingWithoutSaving')} />
      <Grid container spacing={1}>
        <Grid item xs={4}>
          {!insurance.hisOwnInsurance && (
            <Autocomplete
              id={'offerInsuranceCard_company'}
              label={t('OfferEdit.Insurance.Company')}
              fullWidth={true}
              labelKey='name'
              valueKey='insuranceCompanyId'
              value={insurance.company}
              isSearchable={false}
              simpleValue={false}
              isClearable={false}
              onChange={onInsurancePropertyChange('company')}
              options={companies}
              disabled={readOnlyFull}
            />
          )}
        </Grid>
        <Grid item xs={12}>
          {!insurance.hisOwnInsurance && products && products.length > 0 && (
            <OfferInsuranceProductList companies={companies} products={products} onProductPropertyChange={onProductPropertyChange} />
          )}
        </Grid>
        <Grid hidden={true} item xs={12}>
          <FormControlLabel
            control={
              <Switch
                id={'offerInsuranceCard_isHisOwnInsurance'}
                checked={insurance.hisOwnInsurance || false}
                onChange={onCheckBoxChange(onInsurancePropertyChange('hisOwnInsurance'))}
                disabled={readOnlyFull}
              />
            }
            label={t('OfferEdit.Insurance.HisOwnInsurance')}
          />
        </Grid>
        {isValid ? (
          <Button
            id={'offerInsuranceCard_saveBtn'}
            color='primary'
            onClick={onSave}
            style={{ marginTop: 40 }}
            disabled={readOnlyFull || saving || insuranceLoading || productsLoading || !(isNew || isDirty)}
          >
            {saving ? t('Saving') + '...' : t('Save')}
          </Button>
        ) : (
          <Tooltip title={t('Tooltips.InsuranceSelection')}>
            <Button
              id={'offerInsuranceCard_saveBtn'}
              color='primary'
              onClick={onSave}
              style={{ marginTop: 40 }}
              disabled={readOnlyFull || saving || insuranceLoading || productsLoading || !(isNew || isDirty)}
            >
              {saving ? t('Saving') + '...' : t('Save')}
            </Button>
          </Tooltip>
        )}
      </Grid>
    </form>
  );
};

OfferInsurance.propTypes = {
  insurance: PropTypes.object.isRequired,
  products: PropTypes.array,
  companies: PropTypes.array.isRequired,
  onInsurancePropertyChange: PropTypes.func.isRequired,
  onProductPropertyChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  insuranceLoading: PropTypes.bool.isRequired,
  productsLoading: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool.isRequired,
  isValid: PropTypes.bool,
  t: PropTypes.func.isRequired
};

export default withTranslation()(OfferInsurance);
